<template>
    <div class="content content-1">

        <SplitText :is-type="'h1'" class="t-h1 title anim-line-3">
            <span>
                Automate to grow
            </span>
        </SplitText>

        <div class="t-text block u-relative">

            <p class="text anim-2">
                <span>
                    We help you automate the repetitive and build a well-oiled machine.
                </span>
            </p>

            <ul class="list anim-1">
                <li class="item">
                    Process planning
                </li>
                <li class="item">
                    Admin automation
                </li>
                <li class="item">
                    Social media automation
                </li>
                <li class="item">
                    Sales automation
                </li>
                <li class="item">
                    Networking and outreach
                </li>
            </ul>

        </div>
    </div>
</template>
<script>
import SplitText from '@/components/SplitText'

export default
{
    name: 'Automation',

    components:
    {
        SplitText
    }
}
</script>
